// Short screen-recordings of each step, one per theme. Regenerate from the
// running local app with: node scripts/record-onboarding-media.mjs
export const WIZARD_GIFS = {
  step1: { dark: '/onboarding/welcome-dark.mp4', light: '/onboarding/welcome-light.mp4' },
  step2: {
    dark: '/onboarding/competency-map-dark.mp4',
    light: '/onboarding/competency-map-light.mp4',
  },
  step3: { dark: '/onboarding/profile-dark.mp4', light: '/onboarding/profile-light.mp4' },
  step4: { dark: '/onboarding/review-dark.mp4', light: '/onboarding/review-light.mp4' },
  step5: { dark: '/onboarding/admin-dark.mp4', light: '/onboarding/admin-light.mp4' },
};
